"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const images = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-images` : '') + (description ? ` desc-images` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-images"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-images"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#000",
    d: "M1.688 3.75c.364 0 .662.284.686.642l.001.045v16.5c0 .365.284.663.642.686l.046.002h16.5a.687.687 0 0 1 .045 1.373l-.046.002h-16.5a2.063 2.063 0 0 1-2.06-1.996L1 20.937v-16.5c0-.38.308-.687.688-.687ZM22.313 1c.38 0 .687.308.687.688v17.875c0 .38-.308.687-.688.687H4.438a.687.687 0 0 1-.687-.688V1.688c0-.38.308-.687.688-.687h17.875Zm-.688 1.375h-16.5v16.5h16.5v-16.5Zm-6.17 6.72c.455.004.878.233 1.133.613l3.547 5.35a.688.688 0 0 1-.573 1.067H8.582a.687.687 0 0 1-.571-1.07l2.334-3.496a1.375 1.375 0 0 1 2.002-.311l.561.448 1.407-2.009a1.374 1.374 0 0 1 1.072-.59l.069-.001Zm-.01 1.376-1.83 2.614a.687.687 0 0 1-.993.143l-1.133-.906-1.621 2.428h8.414l-2.838-4.279ZM8.905 6.5a1.031 1.031 0 1 1-.057.002l.057-.002Z"
  }));
};
var _default = exports.default = images;